import { MessagesSquareIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
  PageSubHeader,
  PageSubHeaderBreadcrumbs,
  PageSubHeaderDeskDropdown,
} from '@/components/organisms/PageSubHeader';
import { DeskDropdown } from '@/components/organisms/PageSubHeader/DeskDropdown';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
} from '@/components/ui/breadcrumb';

const ChatsHeader = () => {
  const { t } = useTranslation();

  return (
    <PageSubHeader
      breadcrumbs={
        <PageSubHeaderBreadcrumbs>
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbPage>
                  <div className="flex size-8 items-center justify-center">
                    <MessagesSquareIcon size={16} className="text-foreground-muted" />
                  </div>
                  <div className="mr-4 ml-2 h-4 w-px bg-border" />
                  <span className="text-sm leading-5 font-normal">{t('common.chats')}</span>
                </BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </PageSubHeaderBreadcrumbs>
      }
      deskDropdown={
        <PageSubHeaderDeskDropdown>
          <DeskDropdown />
        </PageSubHeaderDeskDropdown>
      }
    />
  );
};

export default ChatsHeader;
